import createPersistedState from 'vuex-persistedstate'
import { parse } from 'cookie'
import LZString from 'lz-string'
import { PersistentStorageKeys } from '@/enums/app'
import { getCookieDomain } from '@/utils/cookie'

const getItem = ({ key, req, app }) => {
  if (process.server) {
    let headerCookies = req.headers.cookie

    if (typeof headerCookies !== 'string') {
      headerCookies = ''
    }

    const parsedCookies = parse(headerCookies)

    return LZString.decompressFromBase64(parsedCookies[key])
  } else {
    return LZString.decompressFromBase64(app.$cookies.get(key))
  }
}

const lastWrittenValues = {}

const setItem = ({ key, value, app }) => {
  const newCompressedValue = LZString.compressToBase64(value)
  const currentCompressedValue = app.$cookies.get(key)

  if (lastWrittenValues[key] === newCompressedValue) {
    return
  }

  if (currentCompressedValue === newCompressedValue) {
    lastWrittenValues[key] = newCompressedValue
    return
  }

  app.$cookies.set(key, newCompressedValue, {
    expires: new Date(Date.now() + 86400),
    path: '/',
    domain: getCookieDomain()
  })
  lastWrittenValues[key] = newCompressedValue
}

export default ({ store, req, app }) => {
  createPersistedState({
    key: PersistentStorageKeys.general,
    paths: [
      'spaaza',
      'auth.redirectUrl',
      'auth.userId',
      'loqate.lastSearchQuery',
      'loqate.addressIsVerified'
    ],
    storage: {
      getItem: key => getItem({ key, req, app }),
      setItem: (key, value) => setItem({ key, value, app }),
      removeItem: key => app.$cookies.remove(key)
    }
  })(store)

  createPersistedState({
    key: PersistentStorageKeys.menSignup,
    paths: [
      'signup.form',
      'signup.addressConfirmed',
      'signup.currentStep',
      'signup.previousRoute',
      'signup.nextRoute'
    ],
    storage: {
      getItem: key => getItem({ key, req, app }),
      setItem: (key, value) => setItem({ key, value, app }),
      removeItem: key => app.$cookies.remove(key)
    }
  })(store)

  createPersistedState({
    key: PersistentStorageKeys.webshop,
    paths: [
      'webshop'
    ],
    storage: {
      getItem: key => getItem({ key, req, app }),
      setItem: (key, value) => setItem({ key, value, app }),
      removeItem: key => app.$cookies.remove(key)
    }
  })(store)
}
